import { useEffect } from 'react';
import * as React from 'react';

import { FlagSyncLoader } from '@/components/svgs/logo';

import { useLogout } from '@/pages/unauthenticated/auth/mutations/use-logout';

export const LogoutSection = () => {
  const { mutateAsync } = useLogout();

  useEffect(() => {
    (async () => {
      await mutateAsync();
      setTimeout(async () => {
        window.location.href = '/';
      }, 500);
    })();
  }, []);

  return (
    <div className="flex justify-center">
      <FlagSyncLoader className="h-12 w-12" />
    </div>
  );
};
